
/**
 * Use can `'ruby' | 'koala'` for SlotV2 games and `undefined` for old slot games.
 */
export type GameProvider = 'ruby' | 'koala' | undefined;

